"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HtmlComponent = void 0;
var utils_1 = require("../../../utils");
var React = require("react");
exports.HtmlComponent = function (props) {
    return (React.createElement("div", { className: 'component html-component', "data-component-type": 'html' },
        React.createElement(utils_1.RenderHtml, { html: props.value.html, className: 'rendered-html' })));
};
//# sourceMappingURL=html-component.comp.js.map